import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Rectangle, Typography, Cushion, Space, MaxWidth } from '@pitchero/react-ui';
import LoginButton from '../../auth/login-button';
import {
  isLoggedIn as isLoggedInSelector,
  hasCheckedLoginState as hasCheckedLoginStateSelector,
} from '../../../store/auth/selectors';
import { Trans } from '../../../lib/i18n';

const AssigmentsLoginNotice = ({ isLoggedIn, hasCheckedLoginState, background }) => {
  if (isLoggedIn || !hasCheckedLoginState) {
    return null;
  }

  return (
    <Rectangle fill={background}>
      <Cushion
        vertical="xlarge"
        all="large"
        style={{ textAlign: 'center' }}
        component="div"
        responsive={[{ minWidth: 'tab', props: { vertical: 'xxlarge' } }]}
      >
        <Space bottom="xsmall" component="div">
          <Typography preset="staticSubtitle--large">
            <Trans i18nKey="shop:assignments_login_notice_title">Login to see all products</Trans>
          </Typography>
        </Space>
        <Space bottom="medium" component="div">
          <Typography preset="body--small" color="dustygrey">
            <Trans i18nKey="shop:assignments_login_notice_body">
              Some products are only available to logged in members
            </Trans>
          </Typography>
        </Space>
        <MaxWidth component="div" maxWidth={300} center>
          <LoginButton translationKey="shop:login_to_buy_product_button_text" fullWidth />
        </MaxWidth>
      </Cushion>
    </Rectangle>
  );
};

AssigmentsLoginNotice.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  hasCheckedLoginState: PropTypes.bool.isRequired,
  background: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  isLoggedIn: isLoggedInSelector(state),
  hasCheckedLoginState: hasCheckedLoginStateSelector(state),
});

export default connect(mapStateToProps)(AssigmentsLoginNotice);
